export default __webpack_public_path__ + "static/media/me-icon-active.3c1b0c8e.webp";